import { WorkflowStepResponseDto, WorkflowNode } from '@bandido/shared/dtos';
import { WorkflowStepType } from '@bandido/shared/constants';

export const parseSteps = (steps: WorkflowStepResponseDto[]) =>
  steps.map(({ id, color, teams, name, data: stepData, comment, template, isCancelStep }) => {
    const { position: { x = 250, y = 250 } = {}, type = WorkflowStepType.CUSTOM } = JSON.parse(
      stepData ?? '{}',
    ) as WorkflowNode;

    const stepTeams = teams.map((team) => team.id);

    return {
      id,
      data: { name, color, teams: stepTeams, id, comment, template, isCancelStep },
      dragHandle: '.enable-drag-handle',
      type,
      position: { x, y },
    };
  });
